import script from "./User-Management.vue?vue&type=script&setup=true&lang=js"
export * from "./User-Management.vue?vue&type=script&setup=true&lang=js"

import "./User-Management.vue?vue&type=style&index=0&id=d6065dfe&scoped=true&lang=css"

import exportComponent from "/Users/Joe/Documents/Projects/MCR-WebFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6065dfe"]])

export default __exports__